import { render, staticRenderFns } from "./client-layout.pug?vue&type=template&id=7d51e23c&scoped=true&lang=pug&"
var script = {}
import style0 from "./client-layout.scss?vue&type=style&index=0&id=7d51e23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d51e23c",
  null
  
)

export default component.exports